<style scoped>
    .grade-buttons-sm-and-up,
    .grade-buttons-sm-and-down  {
        width: 100%;
    }
    .grade-buttons-sm-and-up .btn {
        width: 20%;
    }

    .grade-buttons-sm-and-up btn span{
        width: 200px;
    }


    .grade-buttons-sm-and-down .btn {
        width: 20%;
    }

    .grade-text {
        font-size: 12px;
    }

    .btn-grade {
        width: 20% !important;
    }

    .btn-grade .v-btn {
        width: 100% !important;
    }

    button.v-btn.v-btn--disabled.v-btn--active { color: green !important; }
</style>

<template>

<div>
    <v-btn-toggle v-model="grade" class="hidden-sm-and-down grade-buttons-sm-and-up">
        <v-tooltip v-for="button in activeSettings" :key="button.id" bottom class="btn-grade" :disabled="button.description == ''">
             <v-btn slot="activator" :value="button.id" v-bind:disabled="readonly"
                v-bind:class="{ 
                    'green': true ,
                    'lighten-5': button.classId == 5, 
                    'lighten-4': button.classId == 4,
                    'lighten-3': button.classId == 3,
                    'lighten-2': button.classId == 2,
                    'lighten-1': button.classId == 1 }"
             >{{ button.text }}
            </v-btn>
            <span>{{ button.description }}</span>
        </v-tooltip>
    </v-btn-toggle>
    <v-alert v-model="error" outline color="error" icon="warning" dismissible>
      {{ errorMessage }}
    </v-alert>
</div>
</template>

<script>
    import { putTeacherEffort, getSettings, initialize } from '../utils/effort-tracking-api'
    import { putStudentEffort, getPeriods } from '../utils/effort-tracking-api'
    import { store } from '../store'
    import { globalStore } from '../main';

    export default {
        props: [ 'value', 'settings', 'readonly', 'active', 'classId'],
        data: function() {
            return {
                grade: Number(this.value[0].grade),
                error: false,
                errorMessage: 'Warning – Connection failed - changes may not have been stored',
                gradeButtonText1: '1 - Unsatisfactory',
                gradeButtonText2: '2 - Fair',
                gradeButtonText3: '3 - Good',
                gradeButtonText4: '4 - Very good',
                gradeButtonText5: '5 - Outstanding',
                buttonDescription1: '',
                buttonDescription2: '',
                buttonDescription3: '',
                buttonDescription4: '',
                buttonDescription5: '',
                activeSettings: []
            }   
        },
        name: 'grading-buttons',
        watch: {
            grade: {
                handler () {
                    var user = this.$store.state.usertype;
                    var route = this.$route.name;
                    if(user == 'admin' || user == 'middlemanager' && route == 'TeacherEfforts')
                        user = 'teacher';

                    if(user == 'admin' && route == 'StudentEfforts')
                        user = 'student';

                    this.value[0].grade = this.grade != null ? this.grade : 0 ;
                    this.updateGrade(user, this.value[0]);
                },
            }
        },

        methods: {
            updateGrade(usertype, data) {
                var periodId = localStorage.getItem('period-selected');
                console.log('Saving grade with data..');
                console.log(data);
                
                this.error = false;
                if ( this.$route.name == 'StudentEfforts' )
                {
                    console.log('As student...');
                    putStudentEffort(data)
                    .then(
                        response =>  { 
                            console.log(response);
                            if (response.success) {
                                this.error = false;
                                this.$emit('grade-changed', data, this.classId);
                            } else {
                                this.error = true;
                                this.$emit('save-failed');
                            }
                        }
                    ).catch(e => {
                        console.log(e);
                        this.error = true;
                        this.$emit('save-failed');
                    });
                    
                } else {
                    
                    if (usertype == 'teacher' || usertype == 'middlemanager')
                    {
                        console.log('As usertype: ' + usertype);
                        putTeacherEffort(data)
                        .then(
                            response => {
                                if (response.success) {
                                    this.$emit('grade-changed', data, this.classId);
                                } else {
                                    this.error = true;
                                    this.$emit('save-failed');
                                }
                            }
                        ).catch(
                            error => {
                                console.log('Something happened:');
                                console.log(error);
                                this.error = true;
                                this.$emit('save-failed');
                            }
                        );
                    }

                }

            },
            update(){
                var buttons = [];
                var descriptions = [];
                this.settings.forEach((element, i) => {
                    var text = '';
                    if(element.key.indexOf('text') != -1)
                    {
                        text = element.value;
                        buttons.push(text);
                    }

                    var descrip = '';
                    if(element.key.indexOf('description') != -1)
                    {
                        descrip = element.value;
                        descriptions.push(descrip);
                    }
                });

                var grades = [];
                var classId = 5;
                this.activeSettings = [];

                for(var i = 1; i < 6; i++) {
                    var setting = {
                        id: i,
                        text: buttons[i - 1],
                        description: descriptions[i - 1],
                        classId: classId
                    };
                    classId--;
                    this.activeSettings.push(setting);
                }

            }
        },

        mounted() {
            var element = document.getElementsByClassName("effort-grades")
            element[0].style.display = 'inline';
            this.update();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/GradingButtons.vue